import { render } from "./OriAlpha.vue?vue&type=template&id=519361a6"
import script from "./OriAlpha.vue?vue&type=script&lang=js"
export * from "./OriAlpha.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__